import { useState } from "react";
import { Get, Set } from "../../../../Request";

export const useQuestions = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    questions: [],
    categories: [],
  });
  const [search, setSearch] = useState({
    category_id: null,
    value: null,
  });
  const getData = async () => {
    setLoading(true);
    await Get({
      url: "/question/show",
      data: search,
    }).then(response => {
      setData({
        questions: response.questions,
        categories: response.categories,
      });
      setLoading(false);
    });
  };
  return { getData, loading, data, search, setSearch };
};
